import React, { useEffect, useState } from "react";
import "./Check_fit_form.css";
import Common_Title from "../common_components/common_title/Common_Title";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";

const Check_fit_form = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [course, setCourse] = useState(null);
  const [students, setStudents] = useState(50);

  const options = [
    { value: "MBA", label: "MBA", fee: "70", duration: "2" },
    { value: "BBA", label: "BBA", fee: "50", duration: "3" },
    { value: "BCA", label: "BCA", fee: "50", duration: "3" },
    { value: "BA", label: "MBA", fee: "40", duration: "3" },
    { value: "MA", label: "BBA", fee: "40", duration: "2" },
    { value: "BCOM", label: "BCA", fee: "30", duration: "3" },
    { value: "MCA", label: "MBA", fee: "60", duration: "2" },
  ];
  const [selectedCourse, setSelectedCourse] = useState(options[0]);


  console.log(selectedCourse,"selectedCourse selectedCourse");
  

  const totalInLakhs = selectedCourse
  ? (students * selectedCourse.fee) / 100
  : 0;
  return (
    <>
      <section className="Check_fit_form_sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="sec1">
                <p className="maxp">
                  Maximize Your Commission Potential across the Broadest
                  Selection of Partner Universities.
                </p>

                <Common_Title
                  simpleText="Swift"
                  darkText="Payout of Earnings"
                />

                <div className="row">
                  <div className="col-lg-6">
                    <form>
                      <div className="form_group">
                        <label className="labelname">Select Course</label>
                        <Select
                          options={options}
                          value={selectedCourse}
                          onChange={(option) => setSelectedCourse(option)}
                          placeholder="Select a course"
                        />
                      </div>
                      <div className="form_group">
                        <label className="labelname">Number of Student</label>
                        <Slider
                          value={students}
                          onChange={(e, val) => setStudents(val)}
                          min={1}
                          max={200}
                          valueLabelDisplay="auto"
                        />
                      </div>

                      <div className="form_group">
                        <Form.Control
                          as="textarea"
                          rows={4}
                          placeholder="Write here..."
                          value={students}
                          onChange={(e) => setStudents(e.target.value)}
                        />
                      </div>
                    </form>
                  </div>

                  {/* <div className="col-lg-6">
                    <div className="unibox">
                      <div className="totaldiv">
                        <p className="totalp">
                          Total <br></br>Earning <br></br>₹5555530{" "}
                        </p>
                      </div>
                      <div className="imgdiv">
                        <p className="unselct">University Selected</p>
                        <p className="dpuname">DPU Pune (Online)</p>
                        <img
                          className="uniimg"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/home/associates/img1.png"
                          }
                          alt="university"
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 my-auto">
              <div className="sec2">
                <Link to={"/registration"}>
                  <button className="becomebtn">Become a Partner</button>
                </Link>
                <img
                  className="sec2icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/check_your_fit/form/Group.png"
                  }
                />
              </div>
            </div>
          </div>

          <div className="tablesec">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="flex-row">
                <Nav.Item>
                  <Nav.Link eventKey="first">Full</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="second">Semester</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Annual</Nav.Link>
                </Nav.Item> */}
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <div className="table-responsive">
                    <table className="table table-responsive">
                      <thead>
                        <tr>
                          <th>Number of Student</th>
                          <th>Duration</th>
                          <th>Earning Per Student</th>
                          <th>Total Take Away</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{students}</td>
                          <td>{selectedCourse?.duration || "-"}</td>
                          <td>{selectedCourse?.fee || "-"} K</td>
                          <td>{totalInLakhs} Lakh</td>
                        </tr>
                       
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="3">
                            <strong>Total</strong>
                          </td>
                          <td>
                            <strong>{totalInLakhs} Lakh</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </Tab.Pane>
                {/* <Tab.Pane eventKey="second">
                  <div className="table-responsive">
                    <table className="table table-responsive">
                      <thead>
                        <tr>
                          <th>Number of Student</th>
                          <th>Duration</th>
                          <th>Earning Per Student</th>
                          <th>Total Take Away</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>55</td>
                          <td>2</td>
                          <td>100</td>
                          <td>5000</td>
                        </tr>
                        <tr>
                          <td>55</td>
                          <td>2</td>
                          <td>100</td>
                          <td>5000</td>
                        </tr>
                        <tr>
                          <td>55</td>
                          <td>2</td>
                          <td>100</td>
                          <td>5000</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="3">
                            <strong>Total</strong>
                          </td>
                          <td>
                            <strong>15000</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <div className="table-responsive">
                    <table className="table table-responsive">
                      <thead>
                        <tr>
                          <th>Number of Student</th>
                          <th>Duration</th>
                          <th>Earning Per Student</th>
                          <th>Total Take Away</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>55</td>
                          <td>2</td>
                          <td>100</td>
                          <td>5000</td>
                        </tr>
                        <tr>
                          <td>55</td>
                          <td>2</td>
                          <td>100</td>
                          <td>5000</td>
                        </tr>
                        <tr>
                          <td>55</td>
                          <td>2</td>
                          <td>100</td>
                          <td>5000</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="3">
                            <strong>Total</strong>
                          </td>
                          <td>
                            <strong>15000</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </Tab.Pane> */}
              </Tab.Content>
            </Tab.Container>

            <div className="note_holder">
              <p><b className="text_red_holder">Note:-</b> <Link to="/terms-conditions">Terms And Conditions</Link> Apply .</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Check_fit_form;
